import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import { Alert, Table, Badge, Button } from 'reactstrap';
import moment from 'moment';
import { GetAllUsersQuery } from './graphql';
import AddNewUser from './AddNewUser';

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      newuser: [],
    };
  }
  showBadge = status => {
    switch (status) {
      case 0:
        return <Badge color="success">Active</Badge>;
      case 2:
        return <Badge color="secondary">Disabled</Badge>;
      default:
        return <Badge color="warning">Inactive</Badge>;
    }
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  updateUserList = user => {
    this.setState({
      newuser: [user, ...this.state.newuser],
    });
    // this.toggle();
  };

  render() {
    const { data: { loading, error, users } } = this.props;
    if (error) {
      return (
        <div>
          <Alert color="danger">Unable to load all users</Alert>
        </div>
      );
    }
    if (loading) {
      return <div>Loading......</div>;
    }
    const formdate = mdate => moment(mdate).fromNow();
    const allusers = [...this.state.newuser, ...users];
    return (
      <div>
        <div style={{ float: 'left', padding: ' 5px 0px 15px 0px' }}>
          <h3>Users</h3>
        </div>
        <div style={{ float: 'right', padding: ' 5px 0px 15px 0px' }}>
          <Button size="sm" color="info" onClick={() => this.toggle()}>
            Add New User
          </Button>
        </div>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Username</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Added On</th>
              <th>Email</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {allusers.map(user => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.username}</td>
                <td>{user.firstname}</td>
                <td>{user.lastname}</td>
                <td>{formdate(user.createdAt)}</td>
                <td>{user.email}</td>
                <td>{this.showBadge(user.status)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        {this.state.modal && (
          <AddNewUser onClick={this.updateUserList} onClose={this.toggle} />
        )}
      </div>
    );
  }
}

const GetAllUsers = compose(graphql(GetAllUsersQuery));
export default GetAllUsers(Users);



// WEBPACK FOOTER //
// ./src/views/Users/users.js